export default __webpack_public_path__ + "static/media/redisDB.b6640ec1.png";